export default __webpack_public_path__ + "static/media/loader.e73fe1be.gif";